import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollOnNavigate() {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
        document.body.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);
}
